import AppCommon from './AppCommon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FilterProvider } from './utils/filterContext';
import './assets/css/App.css';
/**
 * App component serves as the main entry point for the web version of the application.
 *
 * It renders the `AppCommon` component and passes the `FontAwesomeIcon` component as a prop,
 * enabling the use of FontAwesome icons in the web environment.
 *
 * @returns {JSX.Element} The root component for the web application, containing common functionality.
 */
const App = () => {
  return (
    <FilterProvider>
      <AppCommon FontAwesomeIcon={FontAwesomeIcon} />
    </FilterProvider>
  );
};

export default App;
